import { GraphQLQueryClass } from "@harea/component";
import { TTimeOffType } from "@harea/component";

export class TimeOffTypesQuery implements GraphQLQueryClass<Array<TTimeOffType>, TResponse> {
    queryKey: string = "Harea.AppointmentEventUsersQuery.Query";

    gql: string = `
        query TimeOffTypesQuery {
            timeofftypes (filter:{}) {
                data {
                    id designation isPaid
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): Array<TTimeOffType> {
        return data.timeofftypes.data;
    }
}

type TResponse = {
    timeofftypes: {
        data: Array<TTimeOffType>;
    }
};
